// Matches backend/wire/ship_detail.go.
//
// ShipDetail (JSON shape received over the WebSocket):
//   {
//     kind: 'ship_detail',
//     viewscreen_id: number, // 1..255, or 0 for "self / no slot"
//     ship_id: string,       // canonical UUID string
//     accel: number,         // world units per tick² (thrust acceleration)
//     max_speed: number,     // world units per tick (speed cap)
//     turn_rate: number,     // radians per tick while rotate input held
//     ship_class: number,
//   }

export const ShipClassPlayer = 0
export const ShipClassInert = 1

export function isShipDetail(obj) {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    obj.kind === 'ship_detail' &&
    typeof obj.viewscreen_id === 'number'
  )
}
